import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { CardBody, Container, ModalBody, Modal } from 'reactstrap';
import { Card } from 'reactstrap';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useDispatch } from 'react-redux';
import { StorePageHeaderName } from '../../store/pageHeader/action';
const AddApprovalRequisition = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Approval Requisition History'));

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const openModal = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };

    const columns = [
        { field: 'Sl_No', sortable: false, resizable: false, headerName: 'Sl.No', width: 190 },
        {
            field: 'Product_Name',
            headerName: 'Product Name',
            headerClassName: 'table-header-background',
            width: 470,
            sortable: false,
            resizable: false,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div>
                        {productName}
                    </div>
                );
            },
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            headerClassName: 'table-header-background',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            resizable: false,
            width: 200,
        },
        {
            field: 'Value',
            headerName: 'Value',
            headerClassName: 'table-header-background',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            resizable: false,
            width: 200,
        },
    ];

    const rows = [
        { id: 1, Sl_No: 1, Product_Name: 'HOBS HB-MARICA', quantity: 2, Value: 5, },
        { id: 2, Sl_No: 1, Product_Name: 'HOBS HB-MARICA', quantity: 2, Value: 5, },
    ];
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className='mb-3' style={{ fontSize: '20px', fontWeight:'500' }}>
                        <span className='me-2'><ArrowBackIcon /></span>
                        <span>Requisition</span>
                    </div>
                    <Card>
                        <CardBody>
                            <div>
                                <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Product Name</th>
                                            <th>Quantity</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        <tr>
                                            <td>1</td>
                                            <td>HOBS-HB-MARICA 3BT 60 DLX-RETAIL</td>
                                            <td>200</td>
                                            <td>10,000</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>HOBS-HB-MARICA 3BT 60 DLX-RETAIL</td>
                                            <td>200</td>
                                            <td>10,000</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>HOBS-HB-MARICA 3BT 60 DLX-RETAIL</td>
                                            <td>200</td>
                                            <td>10,000</td>
                                        </tr>
                                    </tbody>
                                    <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colspan="2">Total :</th>
                                            <td>200</td>
                                            <td>20,000</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                    <div className='mb-2' style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px', marginRight: '8px', marginBottom: '3px', borderTop: '1px solid #ccc', paddingTop: '8px' }}>
                        <Button className="save_button" variant="contained" onClick={openModal}>Approved</Button>
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do You Want To Submit This Requsition</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={closeModal}></i>
                    </div>
                </div>
                <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                <ModalBody className='pt-2'>
                    <div>
                        <div>
                            <p className='mb-0'>If 'Yes', then you won't be able to modify or edit your request or If 'No' , then you can continue your modification.</p>
                        </div>
                    </div>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center">
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3">
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}

export default AddApprovalRequisition;
